<h1 mat-dialog-title>Release financing holds</h1>

<form [formGroup]="form" (ngSubmit)="submit()" novalidate>
  <div mat-dialog-content class="release-financing-holds-dialog">
    <p class="release-message">
      A client's or an end customer's hold also applies to their other invoices,
      and releasing a hold lets financing resume for the invoices it applies to,
      unless another hold still applies.
    </p>

    <div class="holds-label" id="financing-holds-release-label">Holds to release</div>
    <div
      class="hold-options"
      role="group"
      formGroupName="holds"
      aria-labelledby="financing-holds-release-label"
    >
      <mat-checkbox
        *ngFor="let listed of holds; trackBy: trackByHoldId"
        class="hold-option"
        [attr.data-hold-id]="listed.hold.id"
        [formControlName]="listed.control"
      >
        <span class="hold-description">{{ listed.description }}</span>
        <span class="hold-placed">
          Placed by {{ listed.hold.placed_by?.name }} on {{ listed.hold.placed_at | date: 'd.M.yyyy' }}
        </span>
      </mat-checkbox>
    </div>

    <mat-form-field class="full-width">
      <mat-label>Note</mat-label>
      <textarea
        matInput
        rows="3"
        class="note-input"
        placeholder="Why can financing resume?"
        formControlName="note"
      ></textarea>
      <mat-hint>Kept with the history of each released hold.</mat-hint>
    </mat-form-field>

    <p class="error-message" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
    <button mat-button type="submit" color="primary" class="confirm-button" [disabled]="!canSubmit">{{ submitLabel }}</button>
  </div>
</form>
